import { IPaginatedRequest } from '@cbgms/api'
import { PUTAutomatedBreakSettingsBody } from '@cbgms/api/modules/clocking-actions'
import { getAutomatedBreakSettings, updateAutomatedBreakSetting } from '@cbgms/api/modules/clocking-actions/requests'
import {
  GETClockingItemResponse,
  GETClockingItemsResponse,
  POSTClockingItemBody,
  POSTClockingItemResponse,
  PUTClockingItemBody,
  PUTClockingItemResponse
} from '@cbgms/api/modules/clocking-items'
import * as requests from '@cbgms/api/modules/clocking-items/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const GET_CLOCKING_ITEMS = 'GET_CLOCKING_ITEMS'
export const GET_CLOCKING_ITEMS_SUCCESS = 'GET_CLOCKING_ITEMS_SUCCESS'
export const GET_CLOCKING_ITEMS_FAILED = 'GET_CLOCKING_ITEMS_FAILED'

export const listClockingItems = (params: IPaginatedRequest, shopID?: string) =>
  AsyncAction<GETClockingItemsResponse>({
    type: [GET_CLOCKING_ITEMS, GET_CLOCKING_ITEMS_SUCCESS, GET_CLOCKING_ITEMS_FAILED],
    payload: {
      api: 'gms',
      request: requests.listClockingItems(params, shopID)
    }
  })

export const GET_CLOCKING_ITEM = 'GET_CLOCKING_ITEM'
export const GET_CLOCKING_ITEM_SUCCESS = 'GET_CLOCKING_ITEM_SUCCESS'
export const GET_CLOCKING_ITEM_FAILED = 'GET_CLOCKING_ITEM_FAILED'

export const getClockingItem = (clockingItemUUID: string) =>
  AsyncAction<GETClockingItemResponse>({
    type: [GET_CLOCKING_ITEM, GET_CLOCKING_ITEM_SUCCESS, GET_CLOCKING_ITEM_FAILED],
    payload: {
      api: 'gms',
      request: requests.getClockingItem(clockingItemUUID)
    }
  })

export const CREATE_CLOCKING_ITEM = 'CREATE_CLOCKING_ITEM'
export const CREATE_CLOCKING_ITEM_SUCCESS = 'CREATE_CLOCKING_ITEM_SUCCESS'
export const CREATE_CLOCKING_ITEM_FAILED = 'CREATE_CLOCKING_ITEM_FAILED'

export const createClockingItem = (data: POSTClockingItemBody) =>
  AsyncAction<POSTClockingItemResponse>({
    type: [CREATE_CLOCKING_ITEM, CREATE_CLOCKING_ITEM_SUCCESS, CREATE_CLOCKING_ITEM_FAILED],
    payload: {
      api: 'gms',
      request: requests.createClockingItem(data)
    }
  })

export const UPDATE_CLOCKING_ITEM = 'UPDATE_CLOCKING_ITEM'
export const UPDATE_CLOCKING_ITEM_SUCCESS = 'UPDATE_CLOCKING_ITEM_SUCCESS'
export const UPDATE_CLOCKING_ITEM_FAILED = 'UPDATE_CLOCKING_ITEM_FAILED'

export const updateClockingItem = (clockingItemUUID: string, data: PUTClockingItemBody) =>
  AsyncAction<PUTClockingItemResponse>({
    type: [UPDATE_CLOCKING_ITEM, UPDATE_CLOCKING_ITEM_SUCCESS, UPDATE_CLOCKING_ITEM_FAILED],
    payload: {
      api: 'gms',
      request: requests.updateClockingItem(clockingItemUUID, data)
    }
  })

export const GET_AUTOMATED_BREAK = 'GET_AUTOMATED_BREAK'
export const GET_AUTOMATED_BREAK_SUCCESS = 'GET_AUTOMATED_BREAK_SUCCESS'
export const GET_AUTOMATED_BREAK_FAILED = 'GET_AUTOMATED_BREAK_FAILED'

export const loadAutomatedBreakSettings = () => ({
  type: [GET_AUTOMATED_BREAK, GET_AUTOMATED_BREAK_SUCCESS, GET_AUTOMATED_BREAK_FAILED],
  payload: {
    api: 'gms',
    request: getAutomatedBreakSettings()
  }
})

export const UPDATE_AUTOMATED_BREAK = 'UPDATE_AUTOMATED_BREAK'
export const UPDATE_AUTOMATED_BREAK_SUCCESS = 'UPDATE_AUTOMATED_BREAK_SUCCESS'
export const UPDATE_AUTOMATED_BREAK_FAILED = 'UPDATE_AUTOMATED_BREAK_FAILED'

export const updateAutomatedBreakSettingRequest = (data: PUTAutomatedBreakSettingsBody) => ({
  type: [UPDATE_AUTOMATED_BREAK, UPDATE_AUTOMATED_BREAK_SUCCESS, UPDATE_AUTOMATED_BREAK_FAILED],
  payload: {
    api: 'gms',
    request: updateAutomatedBreakSetting(data)
  }
})
